import { isDefined } from "@clipboard-health/util-ts";
import { useShiftModalsDataContext } from "@src/appV2/redesign/ShiftDiscovery/useShiftModalsDataContext";
import { isEmpty } from "lodash";

import { type BlockingRequirementsContext } from "../../Bookability/Documents/types";
import { ShiftBottomSheetBlockingRequirementsCard } from "./Card";
import { getIndividualBlockingRequirements } from "./getIndividualBlockingRequirements";
import { ShiftBottomSheetGroupedBlockingRequirementsCard } from "./GroupedCard";
import { shouldGroupBlockingRequirementCards } from "./shouldGroupBlockingRequirementCards";

interface ShiftBottomSheetBlockingRequirementsContainerProps {
  shiftId: string;
  blockingRequirementsContext?: BlockingRequirementsContext;
  hasExternalBlockingCards: boolean;
  workplaceId: string;
}

export function ShiftBottomSheetBlockingRequirementsContainer(
  props: ShiftBottomSheetBlockingRequirementsContainerProps
) {
  const { shiftId, hasExternalBlockingCards, workplaceId, blockingRequirementsContext } = props;

  const { resolvedShiftQualification } = useShiftModalsDataContext();

  if (!isDefined(blockingRequirementsContext)) {
    return null;
  }

  const {
    inReviewVisibleBlockingRequirements,
    notInReviewVisibleBlockingRequirements,
    visibleBlockingRequirements,
    invisibleBlockingRequirements,
  } = blockingRequirementsContext;

  if (
    shouldGroupBlockingRequirementCards({
      inReviewVisibleBlockingRequirements,
      notInReviewVisibleBlockingRequirements,
    })
  ) {
    return (
      <ShiftBottomSheetGroupedBlockingRequirementsCard
        blockingRequirementsContext={blockingRequirementsContext}
        shiftId={shiftId}
        qualification={resolvedShiftQualification}
        workplaceId={workplaceId}
      />
    );
  }

  const individualBlockingRequirements = getIndividualBlockingRequirements({
    inReviewVisibleBlockingRequirements,
    notInReviewVisibleBlockingRequirements,
    visibleBlockingRequirements,
    invisibleBlockingRequirements,
    hasExternalBlockingCards,
  });

  if (!isEmpty(individualBlockingRequirements)) {
    return (
      <>
        {individualBlockingRequirements.map((individualBlockingRequirement) => (
          <ShiftBottomSheetBlockingRequirementsCard
            key={individualBlockingRequirement.requirementId}
            blockingRequirement={individualBlockingRequirement}
            shiftId={shiftId}
          />
        ))}
      </>
    );
  }

  return null;
}
